module.exports = __webpack_public_path__ + "img/litchi.571e6b3b.png";